namespace Areas {
    "use strict";

    export class Tab {
        id: number;
        url: string;

        constructor(id: number, url: string) {
            this.id = id;
            this.url = url;
        }
    }

    export function createTabsWithSameAction(area: string, action: string, controllers: string[]): Array<Tab> {
        return controllers.map((value, index) => new Tab(index, `/${area}/${value}/${action}`));
    }

    export function createTabsWithSameController(area: string, actions: string[], controller: string): Array<Tab> {
        return actions.map((value, index) => new Tab(index, `/${area}/${controller}/${value}`));
    }

    export function tabInitialized(tabItems: Tab[]) {
        return tabInitializedBase(tabItems, i => new Tab(i.id, i.url));
    }  

    export function tabItemClick(params: any) {
        window.location.href = params.itemData.url;
    } 

    export function tabWithIdInitialized(tabItems: Tab[]) {
        return tabInitializedBase(tabItems, (i, tabControl) => new Tab(i.id, `${i.url}/${tabControl.option("id")}`));
    }

    export function tabWithIdItemClick(params: any) {
        const url = params.itemData.url + "/" + params.component.option("id");
        window.location.href = url;
    }   
    
    function tabInitializedBase(tabItems: Tab[], transform: (t: Tab, tabControl: DevExpress.ui.dxTabs) => Tab) {
        return (params: any) => {
            const tabControl: DevExpress.ui.dxTabs = params.component;
            const currentUrl = window.location.pathname;

            if (matchTabWithExactUrl(tabItems, transform, tabControl, currentUrl)) {
                return;
            }

            tryToMatchTabBySubTabName(tabControl);
        }
    }
    
    function matchTabWithExactUrl(tabItems: Tab[], transform: (t: Tab, tabControl: DevExpress.ui.dxTabs) => Tab,
        tabControl:DevExpress.ui.dxTabs, currentUrl: string): boolean {

        var selectedTab = tabItems
        .map(i => transform(i, tabControl))
        .filter((element) => currentUrl === element.url);

        if (selectedTab.length === 1) {
            tabControl.option("selectedIndex", selectedTab[0].id);
            return true;
        }

        return false;
    }        
    
    function tryToMatchTabBySubTabName(tabControl: DevExpress.ui.dxTabs) {
        var subTabNames = tabControl.option("subTabNames").split(",").map((s) => s.trim());

        var controlItems = tabControl.option("items")
            .map((value, index) => new Tab(index, value.url));
        
        subTabNames.some(subTabName => {
            var tabMatch = controlItems.filter((element: Tab) => element.url.toLowerCase().indexOf(subTabName) > 0);
            var currentUrlMatch = location.href.toLocaleLowerCase().indexOf(subTabName) > 0;

            if (tabMatch.length > 0 && currentUrlMatch) {
                tabControl.option("selectedIndex", tabMatch[0].id);
                return true;
            }
        });    
    }
}
